import { render, staticRenderFns } from "./CustomCarousel.vue?vue&type=template&id=2f9b5663"
import script from "./CustomCarousel.vue?vue&type=script&lang=js"
export * from "./CustomCarousel.vue?vue&type=script&lang=js"
import style0 from "./CustomCarousel.vue?vue&type=style&index=0&id=2f9b5663&prod&lang=postcss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports